import { Button, Form, Input } from 'antd'
import PropTypes from 'prop-types'
import React from 'react'
import Text from 'components/Text'
import { UserOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'

const ForgotPasswordUsernameForm = ({
  error,
  forgotPasswordForm,
  handleCancelForgotPasswordClick,
  handleCognitoForgotPasswordSubmit,
  isResettingPassword,
}) => {
  const { t } = useTranslation()

  return (
    <div className="login__forgot-password-container">
      <Text className="login__sign-in-label">
        {t('login.resetPassword.enterUsernameTitle')}
      </Text>

      <Form
        className="login__sign-in-form"
        form={forgotPasswordForm}
        onFinish={handleCognitoForgotPasswordSubmit}
      >
        <Form.Item
          name="username"
          rules={[{ message: t('login.usernameMissing'), required: true }]}
        >
          <Input
            placeholder={t('login.usernamePlaceholder')}
            prefix={<UserOutlined className="login__form-field-icon" />}
          />
        </Form.Item>

        {error && (
          <Form.Item>
            <Text className="login__sign-in-error login__sign-in-error--small">
              {error}
            </Text>
          </Form.Item>
        )}

        <Form.Item>
          <Button
            className="login__submit-button"
            htmlType="submit"
            loading={isResettingPassword}
            type="primary"
          >
            {t('login.resetPassword.sendCode')}
          </Button>

          <Button
            className="login__submit-button"
            onClick={handleCancelForgotPasswordClick}
            type="secondary"
          >
            {t('login.cancel')}
          </Button>
        </Form.Item>
      </Form>
    </div>
  )
}

ForgotPasswordUsernameForm.propTypes = {
  error: PropTypes.string,
  forgotPasswordForm: PropTypes.object.isRequired,
  handleCancelForgotPasswordClick: PropTypes.func.isRequired,
  handleCognitoForgotPasswordSubmit: PropTypes.func.isRequired,
  isResettingPassword: PropTypes.bool.isRequired,
}

export default ForgotPasswordUsernameForm
